export const GET_CRITERA_TAB = 'GET_CRITERA_TAB';
export const GET_REPORTS_TAB = 'GET_REPORTS_TAB';
export const RESET_SCHEDULE_MODULE_DATA = "RESET_SCHEDULE_MODULE_DATA";
